import { atom } from "recoil"

export const reminderTypesAtom = atom({
    key: "reminderTypesAtom",
    default: []
})

export const reminderRecurrencesAtom = atom({
    key: "reminderRecurrencesAtom",
    default: []
})

export const remindersListAtom = atom({
    key: "remindersListAtom",
    default: []
})
export const reminderPayloadAtom = atom({
    key: "reminderPayloadAtom",
    default: {
        patientId: null,
        name: "",
        reminderTypeId: null,
        deadline: new Date(),
        time: null,
        recurrence: {
            frequency: 1,
            frequencyUnit: "week",
            onlyRecurrenceDate: "",
            recurrenceDays: []
        },
        timeBefore: 10,
        timeBeforeUnit: "minute"
    }
})
